import React, { useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'

import { ReactComponent as CarretDownIcons } from '../../../../assets/icons/carretDown.svg'
import './index.scss'

function Sort({ defaultValue = "", options = [] }) {
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState("")

  function handleClickOption(element) {
    setValue(element.title)
    setOpen(false)
    element.action()
  }

  return (
    <div className="sort">
      <div className={open ? "sort__field sort__field--open" : "sort__field"} onClick={() => setOpen(true)}>
        {value || defaultValue} <CarretDownIcons />
      </div>
      <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
        <div className={open ? "sort__options sort__options--open" : "sort__options"}>
          {options.map((e, i) => (
            <span key={i} onClick={() => handleClickOption(e)}>{e.title}</span>
          ))}
        </div>
      </OutsideClickHandler>
    </div>
  )
}

export default Sort
